import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {UuidLicense} from "../../models/uuid-license.model";
import {UuidLicenseService} from "../../services/uuid-license.service";
import {MessageFormRefreshService} from "../subject/message-service-subject.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'iw-uuid-grid',
  templateUrl: './iw-uuid-grid.component.html',
})
export class IwUuidGridComponent implements OnInit {
  @Input()
  public uuids: UuidLicense[] | undefined = [];
  @Output()
  public changeDisplay: EventEmitter<UuidLicense> = new EventEmitter<UuidLicense>();
  @Output()
  public displayUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private uuidService: UuidLicenseService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private readonly refreshFormMessageService: MessageFormRefreshService,
  ) {}

  private subscriptions = new Subject();

  public ngOnInit(): void {
    this.uuids = this.uuidService.getUuids();
    this.refreshFormMessageService.getMessage().pipe(takeUntil(this.subscriptions)).subscribe(message => {
      if (message && 'uuid' === message) {
        this.uuids = this.uuidService.getUuids();
      }
    });
  }

  public updateTenant(lic: UuidLicense): void {
    this.displayUpdate.emit(true);
    this.changeDisplay.emit(lic);
  }

  public ngOnDestroy() {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  public deleteUuid(lic: UuidLicense): any {
    this.confirmationService.confirm({
      message: this.translate.instant(
        'Do you really want to delete this Uuid License?',
      ),
      header: this.translate.instant('Confirmation'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteUuidLic(lic);
      },
      reject: () => {
        return;
      },
    });
  }

  private deleteUuidLic(lic: UuidLicense): void {
    this.uuidService.deleteUuid(lic).subscribe(
      (res) => {
        setTimeout((): void => {
          this.refreshFormMessageService.sendMessage('uuid');
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Success Message'),
            detail: this.translate.instant('Client deleted'),
          });
        }, 1000);
      },
      (err) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('Error Message'),
            // tslint:disable-next-line: max-line-length
            detail: this.translate.instant('Errors occurred - This uuid could not be removed.'),
          });
        }, 1000);
      },
    );
  }
}
